var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 3.75A1.87 1.87 0 0 0 1.25 5.625v3.75a1.87 1.87 0 0 0 1.875 1.875h3.75A1.87 1.87 0 0 0 8.75 9.375v-3.75A1.87 1.87 0 0 0 6.875 3.75zM15 5a2.497 2.497 0 0 0-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5h22.5c1.383 0 2.5-1.117 2.5-2.5S38.883 5 37.5 5zm0 12.5a2.497 2.497 0 0 0-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5h22.5c1.383 0 2.5-1.117 2.5-2.5s-1.117-2.5-2.5-2.5zM15 30a2.497 2.497 0 0 0-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5h22.5c1.383 0 2.5-1.117 2.5-2.5S38.883 30 37.5 30zM1.25 18.125v3.75a1.87 1.87 0 0 0 1.875 1.875h3.75a1.87 1.87 0 0 0 1.875-1.875v-3.75a1.87 1.87 0 0 0-1.875-1.875h-3.75a1.87 1.87 0 0 0-1.875 1.875M3.125 28.75a1.87 1.87 0 0 0-1.875 1.875v3.75a1.87 1.87 0 0 0 1.875 1.875h3.75a1.87 1.87 0 0 0 1.875-1.875v-3.75a1.87 1.87 0 0 0-1.875-1.875z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list.15caa8356e6bf7031a097b34cd8af3c5.svg";